module.exports = __webpack_public_path__ + "static/sp_sm_1-9b9a36f75708d1014e1b927f133cd826.jpg";